import { Pipe, PipeTransform } from "@angular/core";

/**
 * Filters an array using the property name and search term
 */
@Pipe({
    name: "arraypropertyfilter",
    standalone: true
})
export class ArrayPropertyFilterPipe implements PipeTransform {
    transform(array: any[], property: string, searchTerm: string): any {

        if ((!searchTerm || searchTerm.length === 0) || (!property || property.length === 0)) {
            return array;
        }

        const st:string = searchTerm.toLowerCase();

        if (!array) {
            return array;
        }
        return array.filter(item  => {
            return item[property].toLowerCase().indexOf(st) > -1;
        });
    }
}